import React, { Fragment, PureComponent } from 'react';
import { View, Text, Avatar, ListItem, Badge, TimeStamp, AdminBadge } from 'core';
import { IcoWatch } from 'icons';
import { theme, css, CONV_TYPE, SYS_MSG } from 'constants';
import { getTypingIndicatorText, isMyMessage, isDeletedMsg } from 'selectors';
import * as actions from 'actions';
import { lang } from 'lang';

const styles = css({
    img: {
        marginHorizontal: 5
    },
    last_massage: {
        fontSize: 12,
        color: theme.gray_color_lighten(0.6),
        marginTop: 3
    },
    txt: {
        flex: 1,
        padding: 10
    },
    title: {
        fontSize: 16
    },
    watch: {
        fontSize: 10,
        color: theme.gray_color_lighten(0.6)
    },
    ico_watch: {
        marginTop: 1,
        marginHorizontal: 2,
        color: theme.gray_color_lighten(1)
    },
    sender: {
        fontSize: 12,
        marginTop: 5,
        color: theme.gray_color_lighten(0.8)
    },
    typing_indicator: {
        color: theme.primary_color,
        fontWeight: 'bold'
    },
    time: {
        fontSize: theme.font_sm,
        marginLeft: 5
    },
    online: {
        width: 20,
        height: 20,
        borderRadius: 10,
        borderWidth: 4,
        borderColor: 'white',
        backgroundColor: theme.success_color,
        position: 'absolute',
        left: -30,
        top: 40
    }
});

class ChatListItem extends PureComponent {
    render() {
        const { item, selected } = this.props;
        const watching_count = item.type === CONV_TYPE.GROUP && item.watching && Object.keys(item.watching).length;
        const typing_text = getTypingIndicatorText(item);
        return (
            <ListItem selected={selected} icon={Avatar} size={42} icon_style={styles.img} icon_attr={{ data: item }} onPress={() => actions.selectConv(item)}>
                <View style={styles.txt}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        {item.online && isNaN(item.online) ? <View style={styles.online} /> : null}
                        <Text style={styles.title} ellipsizeMode={'tail'} numberOfLines={1}>
                            {item.title}
                        </Text>
                        <AdminBadge is_admin={item.is_admin} />
                        <View style={{ flex: 1 }} />
                        {watching_count ? <Text style={styles.watch}>{watching_count}</Text> : null}
                        {watching_count ? <IcoWatch style={styles.ico_watch} size={15} /> : null}
                        <TimeStamp only_week style={[styles.time, item.unread_msg && { color: theme.primary_color }]} value={item.last_msg.created} />
                    </View>
                    <View style={{ flexDirection: 'row', alignItems: 'center', height: 40 }}>
                        <View style={{ flex: 1 }}>
                            {typing_text ? (
                                <Text style={styles.last_massage}>{typing_text}</Text>
                            ) : SYS_MSG[item.last_msg.type] ? (
                                <SyetemMsg item={item} />
                            ) : (
                                <UserMsg item={item} />
                            )}
                        </View>
                        <Badge color={theme.primary_color} title={item.unread_msg} />
                    </View>
                </View>
            </ListItem>
        );
    }
}

const UserMsg = ({ item }) => (
    <Fragment>
        {item.type === CONV_TYPE.GROUP ? <Text style={styles.sender}>{isMyMessage(item.last_msg) ? 'You' : item.last_msg.user.name}</Text> : null}
        <Text style={styles.last_massage} ellipsizeMode={'tail'} numberOfLines={1}>
            {isDeletedMsg(item.last_msg)
                ? lang.DELETED_MSG
                : item.last_msg.text ||
                  (typeof lang.USER_LAST_MSG[item.last_msg.type] === 'function' ? lang.USER_LAST_MSG[item.last_msg.type](item.last_msg) : lang.USER_LAST_MSG[item.last_msg.type])}
        </Text>
    </Fragment>
);

const SyetemMsg = ({ item }) => (
    <Text style={styles.last_massage} ellipsizeMode={'tail'} numberOfLines={1}>
        {lang.SYSTEM_LAST_MSG[item.last_msg.type](item.last_msg)}
    </Text>
);

export default ChatListItem;



// WEBPACK FOOTER //
// ./src/components/left/chat_list_item.js